import { render } from "./_recommended.vue?vue&type=template&id=79d43d04"
import script from "./_recommended.vue?vue&type=script&lang=js"
export * from "./_recommended.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/appointments/_recommended.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79d43d04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79d43d04', __exports__)) {
    console.log('reload')
    api.reload('79d43d04', __exports__)
  }
  
  module.hot.accept("./_recommended.vue?vue&type=template&id=79d43d04", () => {
    console.log('re-render')
    api.rerender('79d43d04', render)
  })

}


export default __exports__